import React from 'react';
import axios from 'axios';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

import Loading from './Loading';
import WarningPanel from './WarningPanel';
import FileDownloadButton from './FileDownloadButton';

const FileViewerComponent = ({ id, fileName='Файл ЛК Альянс' }) => {
    const [fileBlob, setFileBlob] = React.useState(null);
    const [contentType, setContentType] = React.useState('');
    const [loading, setLoading] = React.useState(true);
    const [warning, setWarning] = React.useState('');
    const defaultLayoutPluginInstance = defaultLayoutPlugin();

    React.useEffect(() => {
        const token = localStorage.getItem('token');
        setLoading(true);

        axios.get(`/api/view-file/${id}`, {
            responseType: 'blob',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
        .then((response) => {
            console.log('Файл успешно загружен:', response);
            const type = response.headers['content-type'] || 'application/octet-stream';
            setContentType(type);

            const blob = new Blob([response.data], { type });
            setFileBlob(URL.createObjectURL(blob));
        })
        .catch(async (error) => {
            console.error('Ошибка загрузки файла:', error);

            let errorMessage = 'Неизвестная ошибка';
            if (error.response?.data instanceof Blob) {
                try {
                    const text = await error.response.data.text();
                    const json = JSON.parse(text);
                    errorMessage = json.message || error.message;
                } catch {
                    errorMessage = error.message;
                }
            } else {
                errorMessage = error.response?.data?.message || error.message;
            }

            setWarning(`Невозможно отобразить файл: ${errorMessage}`);
        })
        .finally(() => {
            setLoading(false);
        });
    }, [id]);

    if (loading) return <Loading />;
    if (warning) return <WarningPanel text={warning} type="error" />;
    if (!fileBlob) return <a>Не удалось загрузить файл</a>;

    const convertDocToPdfAndView = () => {
        const token = localStorage.getItem('token');
        setLoading(true);

        axios.get(`/api/view-file-as-pdf/${id}`, {
            responseType: 'blob',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
        .then((response) => {
            console.log('Файл успешно загружен:', response);
            const type = response.headers['content-type'] || 'application/octet-stream';
            setContentType(type);

            const blob = new Blob([response.data], { type });
            setFileBlob(URL.createObjectURL(blob));
        })
        .catch(async (error) => {
            console.error('Ошибка загрузки файла:', error);

            let errorMessage = 'Неизвестная ошибка';
            if (error.response?.data instanceof Blob) {
                try {
                    const text = await error.response.data.text();
                    const json = JSON.parse(text);
                    errorMessage = json.message || error.message;
                } catch {
                    errorMessage = error.message;
                }
            } else {
                errorMessage = error.response?.data?.message || error.message;
            }

            setWarning(`Невозможно отобразить файл: ${errorMessage}`);
        })
        .finally(() => {
            setLoading(false);
        });
    };

    // Выбор отображения в зависимости от типа
    if (contentType === 'application/pdf') {
        return (
            <Worker workerUrl="/pdf.worker.min.js">
                <Viewer fileUrl={fileBlob} plugins={[defaultLayoutPluginInstance]} />
            </Worker>
        );
    }

    if (contentType.startsWith('image/')) {
        return (
            <div style={{ textAlign: 'center', height: '100%' }}>
                <img
                    src={fileBlob}
                    alt="Загруженный файл"
                    style={{ maxWidth: '100%', height: 'auto', maxHeight: '100%' }}
                />
            </div>
        );
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px' }}>
            <p>Предпросмотр файла "{fileName ?? '--'}" не поддерживается.</p>
            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '15px'}}>
            <span>
                <FileDownloadButton fileBlob={fileBlob} fileName={fileName} buttonName='Скачать оригинальный файл' />
            </span>
            <button
                type='button'
                className='button'
                onClick={() => convertDocToPdfAndView()}
            >
                <svg xmlns="http://www.w3.org/2000/svg" height="18" width="18" viewBox="0 0 18 18"><title>files 2</title><g stroke-width="1.5" fill="none" stroke="currentColor" class="nc-icon-wrapper"><path d="M6.25,10.75H3.25c-.552,0-1-.448-1-1V2.75c0-.552,.448-1,1-1H7.25l2,2v1" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor"></path><polyline points="6.75 1.75 6.75 3.75 8.75 3.75" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor"></polyline><path d="M15.75,9.25v6c0,.552-.448,1-1,1h-5c-.552,0-1-.448-1-1v-7c0-.552,.448-1,1-1h4l2,2Z" stroke-linecap="round" stroke-linejoin="round"></path><polyline points="13.75 7.25 13.75 9.25 15.75 9.25" stroke-linecap="round" stroke-linejoin="round"></polyline></g></svg>
                Конвертировать в pdf и открыть
            </button>
            </div>
        </div>
    );
};

export default FileViewerComponent;
